export const getUpdatedSelection = (
  currentSelection: string[],
  item: string,
  allItems: string[],
  allLabel: string
): string[] => {
  if (item === allLabel) {
    return currentSelection.length === allItems.length - 1
      ? []
      : allItems.filter((i) => i !== allLabel);
  } else {
    let newSelection: string[];
    if (currentSelection.includes(item)) {
      newSelection = currentSelection.filter((s) => s !== item);
    } else {
      newSelection = [...currentSelection, item];
    }

    const nonAllItems = allItems.filter((i) => i !== allLabel);
    if (newSelection.length === nonAllItems.length) {
      return [...newSelection];
    }

    return newSelection;
  }
};
